import { useTranslation } from '@/hook';
import Typography from '@/components/shared/typography/typography.component';
import {
    DoubleCurvedLine,
    PurchaseCarStep1,
    PurchaseCarStep2,
    PurchaseCarStep3,
} from '../../../../public/Images';
import { FC, Fragment } from 'react';
import Image from 'next/image';
import { BannerStep } from '@/components/purchaseCarSteps/banner/step';

export const PurchaseCarStepsBanner: FC = () => {
    const { t } = useTranslation();
    const renderMarkup = ({ html }) => {
        const splitHtml = html.split('<br/>');
        return (
            <div className={'inline'}>
                {splitHtml.map((part, index) => (
                    <Fragment key={index}>
                        {part}
                        {index < splitHtml.length - 1 && <br />}
                    </Fragment>
                ))}
            </div>
        );
    };
    return (
        <div className={'grid gap-2  grid-rows-1  grid-cols-4'}>
            <div
                className={
                    'flex flex-col gap-2 rounded-lg px-3 py-4 justify-center items-center h-[300px]'
                }
            >
                <div className={'ms-2.5'}>
                    <div className={'inline'}>
                        <Typography
                            variant={'h6Bold'}
                            component="span"
                            className={'text-gray-800 inline'}
                        >
                            {renderMarkup({
                                html: t('purchaseSteps.titlePt1'),
                            })}
                        </Typography>
                        <Typography
                            variant={'h6Bold'}
                            className={'text-primary-700 inline'}
                            component="span"
                        >
                            {renderMarkup({
                                html: t('purchaseSteps.titlePt2'),
                            })}
                        </Typography>
                    </div>
                </div>
                <Image
                    src={DoubleCurvedLine}
                    alt={'line'}
                    width={132}
                    height={'18'}
                    className={'ar:-scale-x-100 '}
                />
            </div>
            <BannerStep
                src={PurchaseCarStep1}
                title={t('purchaseSteps.step1.title')}
                subtitle={t('purchaseSteps.step1.subtitle')}
            />
            <BannerStep
                src={PurchaseCarStep2}
                title={t('purchaseSteps.step2.title')}
                subtitle={t('purchaseSteps.step2.subtitle')}
            />
            <BannerStep
                src={PurchaseCarStep3}
                title={t('purchaseSteps.step3.title')}
                subtitle={t('purchaseSteps.step3.subtitle')}
            />
        </div>
    );
};
